import React, {useState} from 'react';
import './otherHelp.scss';
import {useNavigate} from "react-router-dom";


import {HeadingElement, Button} from "../../../../components";
import CALLING_LADY_IMAGE from 'assets/accounting-finance/f_other_help_image.png';
import {financialHelpData, LinkTypes, sectionId} from "../../../../data/financialHelpData";

const OtherHelp = () => {
    const [links, setLinks] = useState<LinkTypes[]>(financialHelpData);

    const setActiveLink = (id: sectionId) => {
        setLinks((prev) => {
            return prev.map((data) => (data.id === id ?
                {...data, isActive: true} : {...data, isActive: false}))
        })
    }

    return (
        <div className={'other-help'} id={'financial_help'}>
            <div className={'other-help_wrapper max'}>
                <div className={'other-help_wrapper_left'}>
                    <img src={CALLING_LADY_IMAGE} alt=""/>
                </div>
                <div className={'other-help_wrapper_right'}>
                    <div className={'other-help_wrapper_right_content'}>
                        <div className={'other-help_wrapper_right_content_top'}>
                            <HeadingElement/>
                            <h1>We got you covered</h1>
                            <p>The mission of the SBAJ is to support the Jamaican economy by developing the small
                                business sector through:</p>
                        </div>
                        <div className={'other-help_wrapper_right_content_bottom'}>
                            <div className={'other-help_wrapper_right_content_bottom_heading'}>
                                {links.map(({name, isActive, id}) => (
                                    <div
                                        className={["other-help_wrapper_right_content_bottom_heading_link",
                                            isActive ? "link_active" : null].join(' ')}
                                        onClick={() => setActiveLink(id)}
                                        key={name + id}
                                    >
                                        {name}
                                    </div>
                                ))}
                            </div>
                            <div className={'other-help_wrapper_right_content_bottom_info'}>
                                {links.map(({image, heading, paragraph, isActive}, index) => (
                                    isActive &&
                                    <OtherHelpSections key={heading + index} image={image} heading={heading}
                                                       paragraph={paragraph}/>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OtherHelp;


interface OtherHelpSectionProps {
    image: any,
    heading: string,
    paragraph: string
}

const OtherHelpSections: React.FC<OtherHelpSectionProps> = ({image, heading, paragraph}) => {
    const navigate = useNavigate();
    return (
        <div className={'other-help-section'}>
            <div className={'other-help-section_left'}>
                <h2>{heading}</h2>
                <p>{paragraph}</p>
                <Button text={'Learn More'} type={'secondary'} onclick={() => navigate('/registration/')}/>
            </div>
            <div className={'other-help-section_right'}>
                <img src={image} alt=""/>
            </div>
        </div>
    );
};
